import React from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import { FaCheckCircle, FaUserCircle, FaIdCard, FaLaptop, FaBriefcase } from "react-icons/fa";
import "./Drprofileview1.css";
import Doctorimg from "./Image/Doctorimg.png";

function Drprofileview1() {
  return (
    <div className="dr-profile-container">
      {/* Profile Section */}
      <div className="dr-profile-background">
        <div className="d-flex justify-content-start dr-profile-newbutton">
          <div className="dr-profile-newbadge px-3 py-2">New</div>
        </div>

        <div className="d-flex justify-content-center position-relative mt-3">
          <div className="dr-profile-img-wrapper">
            <img src={Doctorimg} alt="Doctor" className="dr-profile-img" />
            <div className="dr-profile-offer-banner">
              15% off Limited Offer
            </div>
          </div>
        </div>

        <div className="mt-3 text-center">
          <p className="fw-bold text-primary">
            Name - Dr. Yasmin | Age - 29 years
          </p>
        </div>
      </div>
      
      <p className="text-dark small fw-semibold text-center">
        Posted 15 minutes back
      </p>

      {/* Personal Information Section */}
      <div className="dr-profile-card mx-auto">
        <div className="dr-profile-header">
          <FaIdCard size={32} className="dr-profile-icon" />
          <span className="dr-profile-title">Personal Information</span>
        </div>

        <div className="dr-profile-card-body">
          {/* Doctor Info */}
          <h5 className="dr-profile-title">
            <FaCheckCircle className="dr-profile-check-icon" /> Doctor
            Information
          </h5>

          <div className="dr-profile-info">
            <div className="info-row">
              <span className="dot"></span> Position - Neurologist
            </div>
            <div className="info-row">
              <span className="dot"></span> Qualification - MBBS | MS
            </div>
            <div className="info-row">
              <span className="dot"></span> Language - TOEFL , IELTS, OET, CAE
            </div>
            <div className="info-row">
              <span className="dot"></span> Country License - OMSB | QCHP
            </div>
            <div className="info-row">
              <span className="dot"></span> Religion - Muslim
            </div>
            <div className="info-row">
              <span className="dot"></span> Nationality - Indian
            </div>
            <div className="info-row">
              <span className="dot"></span> Current Location - India
            </div>
            <div className="info-row">
              <span className="dot"></span> Gender - Female
            </div>
            <div className="info-row">
              <span className="dot"></span> Marital status - Single
            </div>
            <div className="info-row">
              <span className="dot"></span> Kids - 0
            </div>
            <div className="info-row">
              <span className="dot"></span> Post Internship Clinical exp. - 2 Yrs
            </div>
            <div className="info-row">
              <span className="dot"></span> Post Graduation Clinical exp. - 3 Yrs
            </div>
            <div className="info-row">
              <span className="dot"></span> Total year of exp. as a Doctor - 6 Yrs
            </div>
          </div>

          {/* Hospital and Qualifications Sections */}
          <h5 className="dr-profile-title mt-4">
            <FaCheckCircle className="dr-profile-check-icon" /> Current
            Hospital Name, Starting & Ending Date
          </h5>
          <div className="dr-hospital-row">
            <div className="dr-profile-box">Mina Tae Hospital</div>
            <div className="dr-profile-box">India</div>
          </div>
          <div className="dr-hospital-row">
            <div className="dr-profile-box">24/10/2019</div>
            <div className="dr-profile-box">Running</div>
          </div>

          <h5 className="dr-profile-title mt-4">
            <FaCheckCircle className="dr-profile-check-icon" /> Previous
            Hospital Name , Starting & Ending Date
          </h5>
          <div className="dr-hospital-row">
            <div className="dr-profile-box">Mina Tae Hospital</div>
            <div className="dr-profile-box">India</div>
          </div>
          <div className="dr-hospital-row">
            <div className="dr-profile-box">24/10/2019</div>
            <div className="dr-profile-box">24/10/2024</div>
          </div>

          <h5 className="dr-profile-title mt-4">
            <FaCheckCircle className="dr-profile-check-icon" /> Fellowship
            Qualifications
          </h5>
          <div className="dr-hospital-row">
            <div className="dr-profile-box">FRCP</div>
            <div className="dr-profile-box">FRCS</div>
            <div className="dr-profile-box">FACP</div>
            <div className="dr-profile-box">FIC</div>
          </div>

          <h5 className="dr-profile-title mt-4">
            <FaCheckCircle className="dr-profile-check-icon" /> Other
            Language Qualifications
          </h5>
          <div className="dr-hospital-row">
            <div className="dr-profile-box">DELF</div>
            <div className="dr-profile-box">TCF</div>
          </div>

          <h5 className="dr-profile-title mt-4">
            <FaCheckCircle className="dr-profile-check-icon" /> Language
            Proficiency Levels
          </h5>
          <div className="dr-hospital-row">
            <div className="dr-profile-box">Basic language skill</div>
            <div className="dr-profile-box">Elementary language skills</div>
          </div>

          <h5 className="dr-profile-title mt-4">
            <FaCheckCircle className="dr-profile-check-icon" />Cultural Adaptation Qualifications
          </h5>
          <div className="dr-hospital-row">
            <div className="dr-profile-box">Cultural Competence in Healthcare</div>
            <div className="dr-profile-box">Cross-Cultural Communication</div>
          </div>

          <h5 className="dr-profile-title mt-4">
            <FaCheckCircle className="dr-profile-check-icon" /> Prometric Certificate
          </h5>
          <div className="dr-hospital-row">
            <div className="dr-profile-box">Yes</div>
          </div>

          <h5 className="dr-profile-title mt-4">
            <FaCheckCircle className="dr-profile-check-icon" />Prometric Certificate Issuing Country
          </h5>
          <div className="dr-hospital-row">
            <div className="dr-profile-box">India</div>
          </div>

          <h5 className="dr-profile-title mt-4">
            <FaCheckCircle className="dr-profile-check-icon" />Data flow certificate
          </h5>
          <div className="dr-hospital-row">
            <div className="dr-profile-box">Yes</div>
          </div>

          <h5 className="dr-profile-title mt-4">
            <FaCheckCircle className="dr-profile-check-icon" /> Data flow certificate Issuing Country
          </h5>
          <div className="dr-hospital-row">
            <div className="dr-profile-box">India</div>
          </div>

          <h5 className="dr-profile-title mt-4">
            <FaCheckCircle className="dr-profile-check-icon" /> My Preferred country for a job
          </h5>
          <div className="dr-hospital-row">
            <div className="dr-profile-box">Qatar</div>
            <div className="dr-profile-box">Dubai</div>
            <div className="dr-profile-box">Singapore</div>
            <div className="dr-profile-box">Japan</div>
          </div>

          <h5 className="dr-profile-title mt-4">
            <FaCheckCircle className="dr-profile-check-icon" /> Language Skilled
          </h5>
          <div className="dr-hospital-row">
            <div className="dr-profile-box">English</div>
            <div className="dr-profile-box">Hindi</div>
            <div className="dr-profile-box">Arabic</div>
          </div>

          <h5 className="dr-profile-title mt-4">
            <FaCheckCircle className="dr-profile-check-icon" /> I have Doctor License From
          </h5>
          <div className="dr-hospital-row">
            <div className="dr-profile-box">Qatar</div>
            <div className="dr-profile-box">India</div>
            <div className="dr-profile-box">Dubai</div>
          </div>

          <h5 className="dr-profile-title mt-4">
            <FaCheckCircle className="dr-profile-check-icon" />I have Driving License From
          </h5>
          <div className="dr-hospital-row">
            <div className="dr-profile-box">India</div>
          </div>

          <div className="dr-profile-header">
            <FaUserCircle className="dr-profile-icon" />
            <span className="dr-profile-title">Professional Information</span>
          </div>

          <div className="dr-profile-body">
            <h5 className="dr-profile-title mt-4">
              <FaCheckCircle className="dr-profile-check-icon" />My Medical Specialties Job Position
            </h5>
            <div className="dr-hospital-row">
              <div className="dr-profile-box">Neurologist</div>
            </div>

            {/* Surgical Specialty */}
            <h5 className="dr-profile-title mt-4">
              <FaCheckCircle className="dr-profile-check-icon" />My Surgical Specialties Job Position
            </h5>
            <div className="dr-hospital-row">
              <div className="dr-profile-box">Neurosurgeon</div>
            </div>

            <h5 className="dr-profile-title mt-4">
              <FaCheckCircle className="dr-profile-check-icon" />Other Medical Specialties Job Position
            </h5>
            <div className="dr-hospital-row">
              <div className="dr-profile-box">Pain Management Specialist</div>
            </div>

            <h5 className="dr-profile-title mt-4">
              <FaCheckCircle className="dr-profile-check-icon" />My Academic and Research Job Position
            </h5>
            <div className="dr-hospital-row">
              <div className="dr-profile-box">Medical Educator</div>
            </div>

            <h5 className="dr-profile-title mt-4">
              <FaCheckCircle className="dr-profile-check-icon" />My Administrative and Leadership Job Position
            </h5>
            <div className="dr-hospital-row">
              <div className="dr-profile-box">Hospital Administrator</div>
            </div>

            <h5 className="dr-profile-title mt-4">
              <FaCheckCircle className="dr-profile-check-icon" />Job Type
            </h5>
            <div className="dr-hospital-row">
              <div className="dr-profile-box">Full Time</div>
            </div>

            <h5 className="dr-profile-title mt-4">
              <FaCheckCircle className="dr-profile-check-icon" />Current work status
            </h5>
            <div className="dr-hospital-row">
              <div className="dr-profile-box">Finish contract</div>
            </div>

            <h5 className="dr-profile-title mt-4">
              <FaCheckCircle className="dr-profile-check-icon" />Visa Type
            </h5>
            <div className="dr-hospital-row">
              <div className="dr-profile-box">Employment Visa</div>
            </div>
          </div>
        </div>
      </div>

      {/* Job Preference Section */}
      <div className="dr-profile-card mx-auto mt-4">
        <div className="dr-profile-header">
          <FaLaptop size={37} className="dr-profile-icon" />
          <span className="dr-profile-title">Your preference for job</span>
        </div>
        
        <div className="dr-profile-card-body">
          <h5 className="dr-profile-title mt-4">
            <FaCheckCircle className="dr-profile-check-icon" /> Prefer job Location
          </h5>
          <div className="dr-hospital-row">
            <div className="dr-profile-box">Qatar</div>
            <div className="dr-profile-box">Dubai</div>
            <div className="dr-profile-box">Singapore</div>
          </div>

          <h5 className="dr-profile-title mt-4">
            <FaCheckCircle className="dr-profile-check-icon" />I would like to start my job
          </h5>
          <div className="dr-hospital-row">
            <div className="dr-profile-box">12/05/2025</div>
          </div>

          <h5 className="dr-profile-title mt-4">
            <FaCheckCircle className="dr-profile-check-icon" />Job position I am applying for
          </h5>
          <div className="dr-hospital-row">
            <div className="dr-profile-box">Neurologist</div>
          </div>

          <h5 className="dr-profile-title mt-4">
            <FaCheckCircle className="dr-profile-check-icon" /> My Expectation
          </h5>

          <div className="dr-hospital-row">
            <div className="dr-profile-box">
              <div className="dr-profile-item">
                <span className="dr-profile-dot"></span>
                <span>Salary - Negotiable</span>
              </div>
              <div className="dr-profile-item">
                <span className="dr-profile-dot"></span>
                <span>Day Off - Flexible</span>
              </div>
              <div className="dr-profile-item">
                <span className="dr-profile-dot"></span>
                <span>Accommodation-: Live in - Separate room</span>
              </div>
            </div>
          </div>

          <div className="dr-profile-header mt-4">
            <FaBriefcase size={37} className="dr-profile-icon" />
            <span className="dr-profile-title">What is your previous experience</span>
          </div>

          <h5 className="dr-profile-title mt-4">
            <FaCheckCircle className="dr-profile-check-icon" /> My Previous Medical Specialties Job Position
          </h5>
          <div className="dr-hospital-row">
            <div className="dr-profile-box">Neurologist</div>
          </div>

          <h5 className="dr-profile-title mt-4">
            <FaCheckCircle className="dr-profile-check-icon" /> My Previous Surgical Specialties Job Position
          </h5>
          <div className="dr-hospital-row">
            <div className="dr-profile-box">Neurosurgeon</div>
          </div>

          <h5 className="dr-profile-title mt-4">
            <FaCheckCircle className="dr-profile-check-icon" /> Other Medical Specialties Job Position (Previous)
          </h5>
          <div className="dr-hospital-row">
            <div className="dr-profile-box">Pain Management Specialist</div>
          </div>

          <h5 className="dr-profile-title mt-4">
            <FaCheckCircle className="dr-profile-check-icon" /> My Previous Academic and Research Job Position
          </h5>
          <div className="dr-hospital-row">
            <div className="dr-profile-box">Medical Educator</div>
          </div>

          <h5 className="dr-profile-title mt-4">
            <FaCheckCircle className="dr-profile-check-icon" /> My Previous Administrative and Leadership Job Position
          </h5>
          <div className="dr-hospital-row">
            <div className="dr-profile-box">Hospital Administrator</div>
          </div>

          <h5 className="dr-profile-title mt-4">
            <FaCheckCircle className="dr-profile-check-icon" />Country have worked before
          </h5>
          <div className="dr-hospital-row">
            <div className="dr-profile-box">Qatar</div>
            <div className="dr-profile-box">Dubai</div>
            <div className="dr-profile-box">Singapore</div>
            <div className="dr-profile-box">Japan</div>
          </div>

          <h5 className="dr-profile-title mt-4">
            <FaCheckCircle className="dr-profile-check-icon" /> Reference letter from your previous employer
          </h5>
          <div className="dr-hospital-row">
            <div className="dr-profile-box">No</div>
          </div>
          
          <h5 className="dr-profile-title mt-4">
            <FaCheckCircle className="dr-profile-check-icon" /> I Have valid passport
          </h5>
          <div className="dr-hospital-row">
            <div className="dr-profile-box">Yes</div>
          </div>

          <div>
            <h5 className="dr-profile-title-aboutme mt-4">About Me</h5>
            <div className="dr-profile-aboutme-box">
              <p>
                Hello sir,<br />
                Hello, I'm Dr. Yasmin, a dedicated and compassionate medical professional
                with a strong passion for delivering exceptional patient care. With a
                wealth of experience and expertise in my field, I am committed to
                providing high-quality healthcare services that prioritize patient
                well-being and satisfaction.
              </p>
              <p>Regards</p>
            </div>
            <div className="dr-profile-report">Report about this post</div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Drprofileview1;